import { last, first, difference, flatMap } from 'lodash';
import { isOfType } from '../../../../ts-utils';
export const getNextChunkState = (state) => {
    var _a, _b, _c, _d;
    const { nextChunkState } = state.topLevelCommentList;
    const lastChunk = lastFetchedChunk(state.topLevelCommentList.chunks);
    if (!lastChunk ||
        !lastChunk.nextCursor ||
        ((_b = (_a = lastChunk.paginationContext) === null || _a === void 0 ? void 0 : _a.remainingCount) !== null && _b !== void 0 ? _b : 0) === 0) {
        return { type: 'NONE' };
    }
    return nextChunkState.type === 'IDLE'
        ? {
            type: 'HAS',
            cursor: lastChunk.nextCursor,
            count: ((_c = lastChunk.paginationContext) === null || _c === void 0 ? void 0 : _c.remainingCount) || 0,
        }
        : {
            type: 'PENDING',
            count: ((_d = lastChunk.paginationContext) === null || _d === void 0 ? void 0 : _d.remainingCount) || 0,
        };
};
export const getPrevChunkState = (state) => {
    var _a, _b, _c, _d;
    const { prevChunkState } = state.topLevelCommentList;
    const firstChunk = firstFetchedChunk(state.topLevelCommentList.chunks);
    if (!firstChunk ||
        !firstChunk.previousCursor ||
        ((_b = (_a = firstChunk.paginationContext) === null || _a === void 0 ? void 0 : _a.offset) !== null && _b !== void 0 ? _b : 0) === 0) {
        return { type: 'NONE' };
    }
    return prevChunkState.type === 'IDLE'
        ? {
            type: 'HAS',
            cursor: firstChunk.previousCursor,
            count: ((_c = firstChunk.paginationContext) === null || _c === void 0 ? void 0 : _c.offset) || 0,
        }
        : {
            type: 'PENDING',
            count: ((_d = firstChunk.paginationContext) === null || _d === void 0 ? void 0 : _d.offset) || 0,
        };
};
// Replies are always sorte
// Next === Older replies
export const getNextReplyChunkState = (repliesState) => {
    var _a;
    if (!repliesState) {
        return { type: 'NONE' };
    }
    const { nextChunkState, chunks = [] } = repliesState;
    const lastChunk = last(chunks.filter(isOfType(['FETCHED', 'INITIAL'])));
    // Some replies might already be fetched with viewReplyTarget action, so we have to subtract
    // them from count (this adjustment needed only on next chunk, because viewReplyTarget will always load
    // older comments)
    const replyTargetIdsCount = difference(chunks.filter(isOfType('REPLY_TARGET')).map((c) => c.commentId), flatMap(chunks.filter(isOfType(['INITIAL', 'FETCHED'])), (c) => c.commentIds)).length;
    if (!lastChunk) {
        return { type: 'NONE' };
    }
    const count = (((_a = lastChunk.paginationContext) === null || _a === void 0 ? void 0 : _a.remainingCount) || 0) - replyTargetIdsCount;
    const cursor = lastChunk.nextCursor ||
        // If replies fetched with limit 0 'nextCursor' is unavailable and we have to use 'pageCursor' instead.
        (lastChunk.type === 'INITIAL' && lastChunk.pageCursor);
    if (!cursor || count < 1) {
        return { type: 'NONE' };
    }
    return nextChunkState.type === 'IDLE'
        ? { type: 'HAS', cursor, count }
        : { type: 'PENDING', count };
};
// Prev === Newer replies
export const getPrevReplyChunkState = (repliesState) => {
    var _a;
    if (!repliesState) {
        return { type: 'NONE' };
    }
    const { prevChunkState, chunks = [] } = repliesState;
    const firstChunk = first(chunks.filter(isOfType(['FETCHED', 'INITIAL'])));
    if (!firstChunk || !firstChunk.previousCursor) {
        return { type: 'NONE' };
    }
    const count = ((_a = firstChunk.paginationContext) === null || _a === void 0 ? void 0 : _a.offset) || 0;
    if (count < 1) {
        return { type: 'NONE' };
    }
    return prevChunkState.type === 'IDLE'
        ? {
            type: 'HAS',
            cursor: firstChunk.previousCursor,
            count,
        }
        : { type: 'PENDING', count };
};
const lastFetchedChunk = (chunks) => last(chunks.filter((c) => c.type === 'FETCHED'));
const firstFetchedChunk = (chunks) => first(chunks.filter((c) => c.type === 'FETCHED'));
//# sourceMappingURL=comments-paging-selectors.js.map